import portugueseMessages from '../../../config/portuguese-messages';

export const requiredField = (fieldValue, { lastMileCompanyInfo }) =>
  lastMileCompanyInfo?.active &&
  !lastMileCompanyInfo?.deliveryEarningsTable?.name
    ? portugueseMessages.ra.validation.required
    : '';

export default { requiredField };
